import { Box, Button, useTheme } from '@mui/material'
import { LoadingButton } from '@mui/lab'

import { useTexts } from './useTexts'

interface Props {
  onDiscard: () => void
  submitting: boolean
  pristine: boolean
  ordersCount: number
  hidden: boolean
  testId?: string
}

export function FormFooter(props: Props) {
  const { submitting, onDiscard, ordersCount, pristine, hidden, testId } = props
  const texts = useTexts()
  const theme = useTheme()

  if (hidden) return null

  return (
    <Box
      gap={theme.spacing(2)}
      display="flex"
      component="footer"
      paddingTop={4}
      paddingLeft={4}
      paddingRight={4}
      flexDirection="row"
      justifyContent="flex-start"
      data-testid={testId}
    >
      <LoadingButton
        size="medium"
        type="submit"
        color="primary"
        variant="contained"
        loading={submitting}
        disabled={submitting || pristine}
        data-testid="orders-bulk-edit-save-button"
        data-trackid="orders-bulk-edit-save-button"
      >
        {texts.save(ordersCount)}
      </LoadingButton>

      <Button
        type="button"
        size="medium"
        color="primary"
        onClick={onDiscard}
        variant="text"
        data-testid="orders-bulk-edit-cancel-button"
        data-trackid="orders-bulk-edit-cancel-button"
      >
        {texts.cancel}
      </Button>
    </Box>
  )
}
